import React from "react";
import { Text } from "@showitinc/showit-wc";

import AnimationProperties from "../../../components/AnimationProperties";
import HoverProperties from "../shared/HoverProperties";
import {
  DEFAULT_HOVER,
  DEFAULT_TRANSITION_IN,
  DEFAULT_TRANSITION_OUT,
} from "../../../constants/AnimationConstants";

const PagePropertiesAnimation = ({ onPropUpdate, page, layout }) => {
  const _onAnimationChange = (propInfo) => {
    onPropUpdate && onPropUpdate(propInfo);
  };

  const pageProps = page.get(layout);
  const defaultTrIn = pageProps.get(DEFAULT_TRANSITION_IN);
  const defaultTrOut = pageProps.get(DEFAULT_TRANSITION_OUT);
  const defaultHover = page.get(DEFAULT_HOVER);

  return (
    <>
      <Text className="panel-subheading">Default Hover</Text>
      <HoverProperties
        hoverPropName={DEFAULT_HOVER}
        elementType="all"
        hover={defaultHover}
        showPageDefault={false}
        showBlockDefault={false}
        onPropUpdate={_onAnimationChange}
      />
      <Text className="panel-subheading">Default In</Text>
      <AnimationProperties
        container={page}
        layout={layout}
        transitionType={DEFAULT_TRANSITION_IN}
        tran={defaultTrIn}
        propPrefix={layout}
        showPageDefault={false}
        showBlockDefault={false}
        onPropUpdate={_onAnimationChange}
      />
      <Text className="panel-subheading">Default Out</Text>
      <AnimationProperties
        container={page}
        layout={layout}
        transitionType={DEFAULT_TRANSITION_OUT}
        tran={defaultTrOut}
        propPrefix={layout}
        showPageDefault={false}
        showBlockDefault={false}
        onPropUpdate={_onAnimationChange}
      />
    </>
  );
};

export default PagePropertiesAnimation;
